import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

const CostHistoryDialog = ({ costHistoryPopup, setCostHistoryPopup }) => (
  <Dialog open={!!costHistoryPopup} onOpenChange={(open) => { if (!open) setCostHistoryPopup(null); }}>
    <DialogContent className="max-w-md z-50" data-testid="cost-history-dialog">
      <DialogHeader>
        <DialogTitle className="text-base font-bold" style={{ fontFamily: 'Nunito' }}>
          Cost History — {costHistoryPopup?.design_code}
        </DialogTitle>
        <p className="text-xs text-gray-500">Last {costHistoryPopup?.history?.length || 0} purchase entries</p>
      </DialogHeader>
      {costHistoryPopup?.history?.length > 0 ? (
        <div className="space-y-2">
          {costHistoryPopup.history.map((h, i) => {
            const prevH = costHistoryPopup.history[i + 1];
            const pctChange = prevH ? (((h.avg_cost - prevH.avg_cost) / prevH.avg_cost) * 100).toFixed(1) : null;
            return (
              <div key={i} className={`flex items-center justify-between p-2.5 rounded-lg border ${i === 0 ? 'bg-blue-50 border-blue-200' : 'bg-gray-50 border-gray-100'}`}>
                <div>
                  <div className="text-xs font-semibold text-gray-800">{h.grn_number}</div>
                  <div className="text-[10px] text-gray-500">{h.vendor} &middot; {h.date}</div>
                  {Object.keys(h.sizes_cost || {}).length > 1 && (
                    <div className="flex gap-1 mt-1 flex-wrap">
                      {Object.entries(h.sizes_cost).map(([sz, c]) => (
                        <span key={sz} className="text-[9px] bg-white border rounded px-1 py-0.5"><span className="text-gray-500">{sz}:</span> <span className="font-bold">₹{c}</span></span>
                      ))}
                    </div>
                  )}
                </div>
                <div className="text-right">
                  <div className="text-sm font-bold text-gray-900">₹{h.avg_cost}</div>
                  {pctChange !== null && (
                    <div className={`text-[10px] font-semibold ${parseFloat(pctChange) > 0 ? 'text-red-500' : parseFloat(pctChange) < 0 ? 'text-green-500' : 'text-gray-400'}`}>
                      {parseFloat(pctChange) > 0 ? '▲' : parseFloat(pctChange) < 0 ? '▼' : '—'} {Math.abs(parseFloat(pctChange))}%
                    </div>
                  )}
                  {i === 0 && <span className="text-[9px] text-blue-600 font-medium">Latest</span>}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="text-sm text-gray-400 text-center py-4">No previous purchase entries found</p>
      )}
    </DialogContent>
  </Dialog>
);

export default CostHistoryDialog;
